import { catchError, from, take, tap } from 'rxjs';
import { enableProdMode } from '@angular/core';
import nodeSettings from 'package.json';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const appConfigPath = 'config.json';

const getAppConfig = from(fetch(appConfigPath).then((res) => res.json())).pipe(
  take(1),
  catchError((err) => fetch(appConfigPath).then((res) => res.json())),
  tap((response) => (window.appConfig = response))
);

getAppConfig.subscribe({
  complete: () => {
    if (environment.production) {
      enableProdMode();
    }

    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  },
});
